import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { getUsers, postUser } from "../../redux/actions/actionUser";

export default function UserCreate() {
  const userForm = {
    name: "",
    lastName: "",
    userId: "",
    pass: "",
  };

  const dispatch = useDispatch();
  const users = useSelector((state) => state.users.allUsers);
  const [user, setUser] = useState(userForm);

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  console.log(users);

  const handleChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {    
    dispatch(postUser(user));
    setUser({
      name: "",
      lastName: "",
      userId: "",
      pass: "",
    });
  };

  return (
    <div className="container m-16">
    <div>
                <p className="text-xl pb-8 underline">Usuarios - Nuevo</p>
            </div>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 w-96">
          <div className="border-b-2 mb-4 pb-2 w-80">
          <div>
            <label>Nombre</label>
            </div>
            <input
              className="border rounded w-1/2"
              type="text"
              name="name"              
              onChange={handleChange}
              value={user.name}
              required={true}
            />
          </div>
          <div className="border-b-2 mb-4 pb-2 w-80">
          <div>
            <label>Apellido</label>
            </div>
            <input
              className="border rounded w-1/2"
              type="text"
              name="lastName"              
              onChange={handleChange}
              value={user.lastName}
              required={true}
            />
          </div>
          <div className="border-b-2 mb-4 pb-2 w-80">
          <div>
            <label>Nombre de Usuario</label>
            </div>
            <input
              className="border rounded w-1/2"
              type="text"
              name="userId"
              placeholder=""
              onChange={handleChange}
              value={user.userId}
              required={true}
            />
          </div>
          <div className="border-b-2 mb-4 pb-2 w-80">
          <div>
            <label>Contraseña</label>
            </div>
            <input
              className="border rounded w-1/2"
              type="password"
              name="pass"
              placeholder=""
              onChange={handleChange}
              value={user.pass}
              required={true}
            />
          </div>
        </div>
        <div>
          <button className="mt-12 p-4 rounded bg-sky-500 text-white">
            Guardar
          </button>
        </div>
      </form>
    </div>
  );
}
